import {Component, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-tab-layout',
  templateUrl: './tab-layout.component.html',
  styleUrl: './tab-layout.component.scss'
})
export class TabLayoutComponent implements OnInit{

  @Input({ required: true }) tabItems: TabItem[]
  // @Output()

  activeIndex: number = 0
  activeSlug: string

  ngOnInit() {
    this.activeIndex = 0
    this.activeSlug = this.tabItems[0]?.slug;
  }

}

export interface TabItem {
  slug: string;
  title: string;
  count?: number
}
